import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

export const createActivity = (data, token) =>
  axios.post(`${baseUrl}/activity`, data, {
    headers: {
      authorization: token,
    },
  });

export const deleteActivity = (id, token) =>
  axios.delete(`${baseUrl}/activity/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const updateActivity = (id, data, token) =>
  axios.patch(`${baseUrl}/activity/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const getActivities = (projectId, query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/activities/${projectId}${qs}`, {
    headers: {
      authorization: token,
    },
  });
};
export const getRecurringActivities = (projectId, query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/activities/${projectId}${qs}`, {
    headers: {
      authorization: token,
    },
  });
};

export const getActivityById = (id, token) =>
  axios.get(`${baseUrl}/activity/${id}`, {
    headers: {
      authorization: token,
    },
  });
export const allActivityAttachment = (myFile, token) => {
  return axios.post(`${baseUrl}/allactivity`, myFile, {
    headers: {
      authorization: token,
    },
  });
};
export const getFormattedFile = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/downloadFinalfile${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
};
